<template>
    <div>
        <p color="primary" class="mb-2">
            <span
                v-if="item.childs && item.childs.length > 0"
                :class="{ 'sort-rotate': collapse === item._id }"
                style="margin: 0 5px;"
                @click="openCollapse(item._id)"
            >
                <FaIcon icon="chevron-left" style="transition: all .5s;" />
            </span>
            <span v-else style="margin: 0 5px;">
                <FaIcon icon="circle" style="font-size: 6px;" />
            </span>
            <span
                @click="filters.product_group_id = item._id, emitCollapse(), filtersSet.product_group_id.value = item.name_fa"
                class="product-group-name"
            >{{ item.name_fa }}</span>
        </p>
        <CCollapse v-if="item.childs && item.childs.length > 0" :show="collapse === item._id">
            <div v-for="elm in item.childs" :key="elm._id" class="mr-2">
                <CustomCollapse @emitCollapse="() => $emit('emitCollapse')" :item="elm" />
            </div>
        </CCollapse>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomCollapse from './CustomCollapse'

export default {
    name: 'CustomCollapse',

    components: {
        CustomCollapse
    },

    props: {
        item: {
            default() {
                return {
                }
            },
            type: Object
        }
    },


    data() {
        return {
            collapse: '',
        }
    },

    computed: {
        ...mapGetters({
            filtersSet: 'product/filtersSet',
            filters: 'product/filters',
        }),
    },

    methods: {
        emitCollapse() {
            this.$emit('emitCollapse')
        },
        openCollapse(id) {
            if (this.collapse === id) {
                this.collapse = ''
                this.subCollapse = ''
            } else {
                this.collapse = id
            }
        },
    }
}
</script>

<style scoped>
.product-group-name {
    cursor: pointer;
}
.product-group-name:hover {
    color: #8412d1;
}
.sort-rotate svg {
    transform: rotate(-90deg);
}
</style>
